import { useDialog } from '@globals/dialog/useDialogStore'
import { ConfirmDialog } from '@shared/dialog/ConfirmDialog'
import { T } from '@transifex/react'
import { FC, useEffect } from 'react'
import { useBlocker } from 'react-router'

type DirtyFormBlockerProps = {
  isFormDirty: boolean
  isSubmitSuccessful: boolean
  onDiscardData?: () => void
  onKeepData?: () => Promise<void>
  dialogKey: string
}
const DirtyFormBlocker: FC<DirtyFormBlockerProps> = ({
  isFormDirty,
  isSubmitSuccessful,
  onDiscardData,
  onKeepData,
  dialogKey,
}) => {
  const { openDialog, closeDialog } = useDialog(dialogKey)

  const navBlocker = useBlocker(() => {
    return isFormDirty
  })

  useEffect(() => {
    if (navBlocker.state === 'blocked' && !isSubmitSuccessful && isFormDirty) {
      return openDialog()
    }
    closeDialog()
    return navBlocker?.proceed?.()
  }, [navBlocker.state])

  const handleClose = () => {
    navBlocker?.reset?.()
  }

  const handleKeepData = () => {
    !!onKeepData && onKeepData()
    handleClose()
    closeDialog()
  }

  const handleDiscard = () => {
    !!onDiscardData && onDiscardData()
    closeDialog()
    navBlocker?.proceed?.()
  }

  return (
    <ConfirmDialog
      dialogKey={dialogKey}
      title={<T _str="Are you sure you want to leave?" />}
      onClose={handleClose}
      onConfirm={handleKeepData}
      onCancel={handleDiscard}
      cancelButtonColor="error"
      cancelButtonText={<T _str="Leave" />}
      confirmButtonText={<T _str="Cancel" />}>
      <T _str="Changes you've made won't be saved." />
    </ConfirmDialog>
  )
}

export default DirtyFormBlocker
